import {EventEmitter} from "@angular/core";
import {BehaviorSubject} from "rxjs";

export class PersistenceGeneralSettings {
  anyChange:EventEmitter<any> = new EventEmitter<any>();
  pageIndex:number;
  pageSize:number;

  autoRefreshChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get autoRefresh():boolean {
    return this.autoRefreshChange.value;
  }
  set autoRefresh(autoRefresh:boolean) {
    this.autoRefreshChange.next(autoRefresh);
    this.emitChange("autoRefresh", autoRefresh);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  toObj():any {
    return {
      autoRefresh: this.autoRefresh,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    };
  }

  setSettings(props:any):void {
    // not setting pageIndex or pageSize as it is set from the persistence service
    this.autoRefreshChange.next(props.autoRefresh || false);
  }
}
